import SchemaHandler from '@exp/exp-utils/schema/schemaHandler';

class AddImpressionHandlerV1 extends SchemaHandler {
  process() {
    super.process({
      ALL: () => { this._handle(); }
    });
  }

  _handle() {
    // call the 'add_event' schema
    this.schemaHelper.handleSchema('add_event', undefined, 'v1', {
      type: 'impression',
      eid: this.data.ALL.eid,
      properties: this.data.ALL.properties,
      dom_element: this.data.ALL.dom_element
    },
    this.extras,
    // this schema's sinks will override add_event's sinks
    this.sinks);
  }
}

export default AddImpressionHandlerV1;
